module.exports = new __parcel__URL__("beaver.72239cbc.svg").toString();